(function () {
  const loader = document.querySelector('[data-bv-loader]');
  if (!loader) return;

  // Skip loader if user has seen it this session
  const seenKey = 'bv_loader_seen';
  const skipForRoute = ['/cart', '/checkouts', '/account'];
  const path = window.location.pathname;

  if (sessionStorage.getItem(seenKey) || skipForRoute.some((p) => path.startsWith(p))) {
    loader.setAttribute('data-state', 'done');
    document.body.classList.remove('bv-loading');
    return;
  }

  document.body.classList.add('bv-loading');

  const hide = () => {
    loader.setAttribute('data-state', 'done');
    document.body.classList.remove('bv-loading');
    sessionStorage.setItem(seenKey, '1');
  };

  // Min display 1.6s (lets the draw animation finish) — max 4s safety net
  const minDelay = 1600;
  const start = performance.now();

  window.addEventListener('load', () => {
    const elapsed = performance.now() - start;
    const wait = Math.max(0, minDelay - elapsed);
    setTimeout(hide, wait);
  });

  setTimeout(hide, 4000);
})();
